module.exports = __webpack_public_path__ + "static/media/phone_illustration_solo.9381bf77.png";